import React from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import './ModernLoadingOverlay.css';

const ModernLoadingOverlay = ({ open, message = 'Loading...' }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'hidden'
        }
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px',
          minWidth: '200px'
        }}
      >
        {/* Modern Spinner */}
        <div className="modern-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-core"></div>
        </div>

        {/* Loading Text */}
        <Typography
          variant="body1"
          sx={{
            marginTop: '24px',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 500,
            letterSpacing: '0.5px',
            textAlign: 'center'
          }}
        >
          {message}
        </Typography>

        {/* Animated Dots */}
        <Box sx={{ marginTop: '8px', display: 'flex', gap: '6px' }}>
          <span className="loading-dot" style={{ animationDelay: '0s' }}></span>
          <span className="loading-dot" style={{ animationDelay: '0.2s' }}></span>
          <span className="loading-dot" style={{ animationDelay: '0.4s' }}></span>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ModernLoadingOverlay;
